module.exports = __webpack_public_path__ + "img/chrity_3.566e2774.png";